import React from "react";
import { useTranslation } from "react-i18next";
import {
  Alert,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Stack,
  Typography,
} from "@mui/material";

export default function MeetingConsentPanel({
  value,
  onChange,
  disabled = false,
  dense = false,
}) {
  const { t } = useTranslation();
  const flags = value || {
    consentClientsInformed: false,
    consentRecordingAccepted: false,
    consentAiAccepted: false,
  };

  const setFlag = (key) => (event) => {
    onChange?.({ ...flags, [key]: event.target.checked });
  };

  const labelSx = {
    alignItems: "flex-start",
    mr: 0,
    ml: 0,
    width: "100%",
    "& .MuiFormControlLabel-label": {
      fontSize: "0.9rem",
      lineHeight: 1.4,
      pt: 0.85,
      wordBreak: "break-word",
    },
  };

  return (
    <Stack spacing={dense ? 1 : 1.5} sx={{ mt: dense ? 1 : 0, minWidth: 0 }}>
      <Alert severity="warning" variant="outlined">
        <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5 }}>
          {t("Meetings.consentTitle")}
        </Typography>
        <Typography variant="body2" sx={{ lineHeight: 1.45 }}>
          {t("Meetings.consentIntro")}
        </Typography>
      </Alert>
      <FormGroup sx={{ gap: 0.5 }}>
        <FormControlLabel
          sx={labelSx}
          control={
            <Checkbox
              checked={Boolean(flags.consentClientsInformed)}
              onChange={setFlag("consentClientsInformed")}
              disabled={disabled}
            />
          }
          label={t("Meetings.consentClients")}
        />
        <FormControlLabel
          sx={labelSx}
          control={
            <Checkbox
              checked={Boolean(flags.consentRecordingAccepted)}
              onChange={setFlag("consentRecordingAccepted")}
              disabled={disabled}
            />
          }
          label={t("Meetings.consentRecording")}
        />
        <FormControlLabel
          sx={labelSx}
          control={
            <Checkbox
              checked={Boolean(flags.consentAiAccepted)}
              onChange={setFlag("consentAiAccepted")}
              disabled={disabled}
            />
          }
          label={t("Meetings.consentAi")}
        />
      </FormGroup>
    </Stack>
  );
}

export function isMeetingConsentComplete(flags = {}) {
  return Boolean(
    flags.consentClientsInformed &&
    flags.consentRecordingAccepted &&
    flags.consentAiAccepted,
  );
}
